import { apiFetch } from '@/lib/api';
import { invalidate } from '@/lib/requestCache';

export interface OAuthStartResponse {
  url: string;
}

export interface OAuthCallbackResponse {
  ig_username: string;
  profile_picture_url: string | null;
  webhook_subscribed: boolean;
}

export const metaOauthService = {
  start(): Promise<OAuthStartResponse> {
    return apiFetch<OAuthStartResponse>('/onboarding/meta/authorize');
  },
  async completeCallback(code: string, state: string): Promise<OAuthCallbackResponse> {
    const result = await apiFetch<OAuthCallbackResponse>('/onboarding/meta/callback', {
      method: 'POST',
      body: JSON.stringify({ code, state }),
    });
    // F070 — connecting the IG account advances the funnel server-side and
    // can flip the operational status; drop both cached shell keys.
    invalidate('onboarding:state', 'bot:status');
    return result;
  },
};
